import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { BusinessUnitProps, BusinessUnitUpdateProps, TBusinessUnitsState } from '../../types'
import { organizationService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseBusinessUnits } from './utils'
import { selectors } from './selectors'
import { businessUnitsAdapter } from './adapter'
import { FetchCollectionParams, FetchCreatedAtParams } from '../../../services/_common'

const name = 'businessUnits'

const initialState: TBusinessUnitsState = {
    ...businessUnitsAdapter.getInitialState(),
    isFetching: false,
    totalItems: 0,
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async (params: FetchCreatedAtParams & FetchCollectionParams | undefined) => {
        const order = params?.order || {'order[name]': 'asc'}

        return parseBusinessUnits(await organizationService.fetchBusinessUnits({
            pagination: params?.pagination,
            page: params?.page,
            perPage: params?.perPage,
            ...order
        }))
    },
    {
        serializeError: parseHttpError
    }
)

const create = createAsyncThunk(
    `${name}/create`,
    async (businessUnit: BusinessUnitProps) => {
        return await organizationService.createBusinessUnit(businessUnit)
    },
    {
        serializeError: parseHttpError
    }
)

const update = createAsyncThunk(
    `${name}/create`,
    async (businessUnit: BusinessUnitUpdateProps) => {
        return await organizationService.updateBusinessUnit(businessUnit)
    },
    {
        serializeError: parseHttpError
    }
)

const remove = createAsyncThunk(
    `${name}/remove`,
    async (id: string) => {
        return await organizationService.removeBusinessUnit(id)
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                state.totalItems = action.payload.totalItems
                businessUnitsAdapter.setAll(state, action.payload.entities)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const businessUnits = {
    name: slice.name,
    actions: {
        fetch,
        create,
        update,
        remove
    },
    reducer: slice.reducer,
    selectors,
}